import React, { useContext, useState } from "react";
import "./styles.css"
import { Card } from "@mui/material";
import language from '../../../nls/language.json';
import Context from "../../../context/Context";

export const IndustryPartsCards = ({ parts, handleFilterCards }) => {
  const {
    selectedCountry,
  } = useContext(Context);



  const date = new Date(Date.now());

  const getDataFormatada = (pedido_Data) => {
    let partesData = pedido_Data.split(".");
    let dataFormatada = `${partesData[1]}/${partesData[0]}/${partesData[2]}`;
    return new Date(Date.parse(dataFormatada));
  }

  console.log("Pecas:", parts);


  return (
    <>
      <div className="d-flex flex-row">

        <div style={{ display: "flex" }}>
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
          >
            <div className="textCard-sm">
              PRETAS
            </div>
            <div className="text-blue textCard-xl">
              {parts.filter(item => (item.cor_HP) === "#000").length}
            </div>
          </Card>
        </div>

        <div style={{ display: "flex" }}>
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
          >
            <div className="textCard-sm">
              VERMELHAS
            </div>
            <div className="text-blue textCard-xl">
              {parts.filter(item => (item.cor_HP) === "#e70000").length}
            </div>
          </Card>
        </div>

        <div style={{ display: "flex" }}>
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
          >
            <div className="textCard-sm">
              PRIORIDADE
            </div>
            <div className="text-blue textCard-xl">
              {((parts.filter((item) => item.cor_HP === "#000").length + parts.filter((item) => item.cor_HP === "#e70000").length) / parts.length * 100).toFixed(0) + "%"}
            </div>
          </Card>
        </div>

        <div className="d-flex">
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
            onClick={() => handleFilterCards("total")}
          >
            <div className="textCard-sm">
              {language[selectedCountry.name].Dashboard.pecasSetor.industryPartsCards.total}
            </div>
            <div className="text-blue textCard-xl">
              {parts.length}
            </div>
          </Card>

          <Card
            align="center"
            className="row-header containerCardStatusPiece"
            onClick={() => handleFilterCards("pedido_data")}
          >
            <div className="textCard-sm">
              {language[selectedCountry.name].Dashboard.pecasSetor.industryPartsCards.atraso}
            </div>
            <div className="text-red textCard-xl">
              {parts.filter((item) => getDataFormatada(item.pedido_Data) < date).length}
            </div>
          </Card>
        </div>
        <div style={{ display: "flex" }}>
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
            onClick={() => handleFilterCards("pend_Key")}
          >
            <div className="textCard-sm">
              {language[selectedCountry.name].Dashboard.pecasSetor.industryPartsCards.pd}
            </div>
            <div className="text-blue textCard-xl">
              {parts.filter(item => (item.pend_Key) != null).length}
            </div>
          </Card>
        </div>
        <div style={{ display: "flex" }}>
          <Card
            align="center"
            className="row-header containerCardStatusPiece"
            onClick={() => handleFilterCards("gsa")}
          >
            <div className="textCard-sm">
              GSA
            </div>
            <div className="text-blue textCard-xl">
              {parts.filter(item => item.gsa?.gsA_Status && item.gsa.gsA_Status !== "LIBERADA").length}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
